<template>
  <v-navigation-drawer :value="isDrawerOpen" app floating width="260" class="app-navigation-menu" :right="$vuetify.rtl"
    @input="val => $emit('update:is-drawer-open', val)">
    <!-- Navigation Header -->
    <div class="vertical-nav-header d-flex items-center ps-6 pe-5 pt-5 pb-2">
      <router-link to="/" class="d-flex align-center text-decoration-none">
        <v-img :src="require('@/assets/images/logos/Icon-Blue.png')" max-height="30px" max-width="30px" alt="logo"
          contain eager class="app-logo me-3"></v-img>
        <v-slide-x-transition>
          <h2 class="app-title text--primary">
            {{ systemName }}
          </h2>
        </v-slide-x-transition>
      </router-link>
    </div>

    <!-- Navigation Items -->
    <v-list expand shaped class="vertical-nav-menu-items pr-5">
      <nav-menu-link :title="$t('dashboard')" :to="{ name: 'school-dashboard' }" :icon="icons.mdiHomeOutline"></nav-menu-link>
      <nav-menu-section-title :title="$t('users')"></nav-menu-section-title>

      <nav-menu-link :title="$t('drivers')" :to="{ name: 'drivers' }" icon="mdi-account-tie-hat"></nav-menu-link>
      <nav-menu-link :title="school_signup == 1 ? $t('students') : $t('passengers')" :to="{ name: 'students' }" icon="mdi-badge-account-outline"></nav-menu-link>
      <nav-menu-section-title :title="$t('system_setup')"></nav-menu-section-title>
      <nav-menu-link :title="school_signup == 1 ? $t('school') : $t('facility_manager')" :to="{ name: 'school' }"
        icon="mdi-school" />

      <nav-menu-link :title="$t('vehicle')" :to="{ name: 'buses' }" icon="mdi-bus-multiple"></nav-menu-link>
      <nav-menu-link v-if="mode === 'advanced'" :title="$t('routes')" :to="{ name: 'routes' }"
        icon="mdi-road-variant"></nav-menu-link>
      <nav-menu-link v-if="mode === 'advanced'" :title="$t('stops')" :to="{ name: 'stops' }"
        icon="mdi-bus-stop"></nav-menu-link>
      <nav-menu-link v-if="mode === 'advanced'" :title="$t('trips')" :to="{ name: 'trips' }"
        icon="mdi-bus-clock"></nav-menu-link>
      <nav-menu-section-title :title="$t('live')"></nav-menu-section-title>
      <nav-menu-link :title="$t('live_tracking')" :to="{ name: 'live-tracking' }" icon="mdi-map-marker"></nav-menu-link>

      <nav-menu-link :title="$t('cctv_feed')" :to="{ name: 'live-tracking' }" icon="mdi-cctv" :disabled="true"></nav-menu-link>
      <nav-menu-section-title :title="$t('reports')"></nav-menu-section-title>
      <nav-menu-link :title="$t('time_table')" :to="{ name: 'planned-trips' }" icon="mdi-airplane-clock"></nav-menu-link>
      <nav-menu-link :title="$t('passenger_rides')" :to="{ name: 'reservations' }" icon="mdi-bus-clock"></nav-menu-link>
      <nav-menu-link v-if="mode === 'advanced'" :title="$t('driver_conflicts')" :to="{ name: 'driver-conflicts' }"
        icon="mdi-alert-circle-outline"></nav-menu-link>
      <nav-menu-section-title :title="$t('plan')"></nav-menu-section-title>
      <nav-menu-link :title="$t('buy')" :to="{ name: 'buy-plans' }" icon="mdi-credit-card-outline"></nav-menu-link>
      <nav-menu-link :title="$t('payments')" :to="{ name: 'school-payments' }"
        icon="mdi-credit-card-multiple-outline"></nav-menu-link>
      <nav-menu-link :title="$t('transfer_coins')" :to="{ name: 'transfer-coins' }"
        icon="mdi-account-cash-outline"></nav-menu-link>
      <br />
    </v-list>
  </v-navigation-drawer>
</template>

<script>

import {
  mdiHomeOutline,
  mdiAlphaTBoxOutline,
  mdiEyeOutline,
  mdiCreditCardOutline,
  mdiTable,
  mdiFileOutline,
  mdiFormSelect,
  mdiAccountCogOutline,
  mdiMapMarkerPath,
  mdiCrosshairsGps
} from '@mdi/js'
import NavMenuSectionTitle from './components/NavMenuSectionTitle.vue'
import NavMenuGroup from './components/NavMenuGroup.vue'
import NavMenuLink from './components/NavMenuLink.vue'
import { Keys } from '/src/config.js'
import auth from '@/services/AuthService'

export default {
  components: {
    NavMenuSectionTitle,
    NavMenuGroup,
    NavMenuLink,
    Keys
  },
  props: {
    isDrawerOpen: {
      type: Boolean,
      default: null,
    },
  },
  setup() {
    return {
      icons: {
        mdiHomeOutline,
        mdiAlphaTBoxOutline,
        mdiEyeOutline,
        mdiCreditCardOutline,
        mdiTable,
        mdiFileOutline,
        mdiFormSelect,
        mdiAccountCogOutline,
        mdiMapMarkerPath,
        mdiCrosshairsGps
      },
      systemName: Keys.VUE_APP_SYSTEM_NAME
    }
  },
  data() {
    return {
      mode: null,
      school_signup: localStorage.getItem('school_signup')
    }
  },
  mounted() {
    this.mode = auth.getMode()
  },
}
</script>

<style lang="scss" scoped>
.app-title {
  font-size: 1.25rem;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.3px;
}

// ? Adjust this `translateX` value to keep logo in center when vertical nav menu is collapsed (Value depends on your logo)
.app-logo {
  transition: all 0.18s ease-in-out;

  .v-navigation-drawer--mini-variant & {
    transform: translateX(-4px);
  }
}

@include theme(app-navigation-menu) using ($material) {
  background-color: map-deep-get($material, 'background');
}

.app-navigation-menu {
  .v-list-item {
    &.vertical-nav-menu-link {
      ::v-deep .v-list-item__icon {
        .v-icon {
          transition: none !important;
        }
      }
    }
  }
}

// You can remove below style
// Upgrade Banner
.app-navigation-menu {
  .upgrade-banner {
    position: absolute;
    bottom: 13px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
